module.exports = __webpack_public_path__ + "img/TImeMatters-NEW-360px.175cea84.png";